import { AlertCircle } from "lucide-react";
import React from "react";
import { Button, Paper, Text, createStyles } from "@mantine/core";
import { SupervisorClockSubmissionSummary } from "../services/model/SupervisorClockSubmission";

const useStyles = createStyles(() => ({
  banner: {
    backgroundColor: "#FFF8F0",
    border: "1px solid #FFD8A8",
    borderRadius: 8,
    padding: "12px 16px",
  },
  icon: {
    color: "#E8590C",
    flexShrink: 0,
  },
}));

interface SupervisorClockBannerProps {
  submission: SupervisorClockSubmissionSummary;
  onViewRequest: () => void;
}

const SupervisorClockBanner: React.FC<SupervisorClockBannerProps> = ({
  submission,
  onViewRequest,
}) => {
  const { classes } = useStyles();

  return (
    <Paper className={classes.banner}>
      <div className="flex flex-col items-stretch gap-sm sm:flex-row sm:items-center sm:justify-between">
        <div className="flex items-start gap-sm flex-1 min-w-0">
          <AlertCircle size={20} className={classes.icon} />
          <div className="min-w-0">
            <Text size="sm" weight={600}>
              New Supervisor Employee Clock in
            </Text>
            <Text size="xs" color="dimmed">
              Please review and approve the employee clock in by Supervisor:{" "}
              {submission.supervisor_name}
            </Text>
          </div>
        </div>
        <Button
          variant="outline"
          size="xs"
          onClick={onViewRequest}
          className="w-full sm:w-auto shrink-0"
        >
          View Request
        </Button>
      </div>
    </Paper>
  );
};

export default SupervisorClockBanner;
